<template>
  <div>
    <div class="e-float-input e-input-group">
      <slot />
      <input
        class="inputElement"
        data-test-input="pswd"
        :type="passwordType"
        :value="value"
        @input="handleKeyEvent($event)"
        v-on:keydown.enter="$emit('handle-enter-key')"
      />
      <span class="e-float-line"></span>
      <label class="e-float-text e-label-top"> {{ placeholder }} </label>
      <span class="e-input-group-icon">
        <font-awesome-icon :icon="['fas', 'eye-slash']" @click="toggleShow" v-show="showPassword" />
        <font-awesome-icon :icon="['fas', 'eye']" @click="toggleShow" v-show="!showPassword" />
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "InputPassword",
  props: {
    value: {
      type: String,
    },
    placeholder: {
      type: String,
    },
  },
  model: {
    prop: "value",
    event: "update",
  },
  data() {
    return {
      showPassword: false,
      passwordType: "password",
    };
  },
  watch: {},
  mounted() {},
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
      if (this.showPassword) {
        this.passwordType = "text";
      } else this.passwordType = "password";
    },
    handleKeyEvent(e) {
      this.$emit("update", e.target.value);
    },
  },
};
</script>

<style>
/* Remove Default browser EYE icon */
input::-ms-reveal,
input::-ms-clear {
  display: none;
}
</style>
